import { ChevronUpIcon } from '@axieinfinity/dango-icons'
import { useReducer } from 'react'

import s from './accordion.module.scss'
import { useCaptureEvent } from '#/hooks'

type Props = React.PropsWithChildren<{
  header: string
}>

export const Accordion: React.FC<Props> = ({ header, children }) => {
  const [open, toggle] = useReducer((value) => !value, false)
  const captureEvent = useCaptureEvent()
  const state = open ? 'open' : 'close'

  return (
    <div className={s.accordion} data-state={state}>
      <button className={s.header} onClick={() => {
        captureEvent('Click FAQ item', { header, state })
        toggle()
      }}>
        {header}
        <ChevronUpIcon className={s.icon} />
      </button>
      <div className={s.content}>{children}</div>
    </div>
  )
}
